<template>
  <div class="statistics">
    <div v-if="existingEntry.data.sexualActivity" class="stat">
      <span class="stat-label">Sexual activity today: </span>

      <span class="stat-stat">
        {{ existingEntry.data.sexualActivity }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">
        Avoided sexual activity today because of pain:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.avoidedSex ? "yes" : "no" }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">
        Interrupted or stopped sexual activity today because of pain:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.interruptedSex ? "yes" : "no" }}
      </span>
    </div>

    <div v-if="existingEntry.data.duringOverall" class="stat">
      <span class="stat-label">
        Pain overall during sex:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.duringOverall / 10 }}
      </span>
    </div>

    <div v-if="existingEntry.data.duringExternal" class="stat">
      <span class="stat-label">
        Pain externally during sex (vulva, clitoris):
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.duringExternal / 10 }}
      </span>
    </div>

    <div v-if="existingEntry.data.duringLower" class="stat">
      <span class="stat-label">
        Pain in lower vagina during sex:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.duringLower / 10 }}
      </span>
    </div>

    <div v-if="existingEntry.data.duringUpper" class="stat">
      <span class="stat-label">
        Pain in upper vagina or deep pelvic during sex:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.duringUpper / 10 }}
      </span>
    </div>

    <div v-if="existingEntry.data.afterOverall" class="stat">
      <span class="stat-label">
        Pain overall after sex:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.afterOverall / 10 }}
      </span>
    </div>

    <div v-if="existingEntry.data.afterExternal" class="stat">
      <span class="stat-label">
        Pain externally after sex (vulva, clitoris):
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.afterExternal / 10 }}
      </span>
    </div>

    <div v-if="existingEntry.data.afterLower" class="stat">
      <span class="stat-label">
        Pain in lower vagina after sex:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.afterLower / 10 }}
      </span>
    </div>

    <div v-if="existingEntry.data.afterUpper" class="stat">
      <span class="stat-label">
        Pain in upper vagina or deep pelvic after sex:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.afterUpper / 10 }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["existingEntry"],
};
</script>

<style></style>
